import { useBridgeApi } from '@/api/BridgeApi.ts';

import type { Chat } from '../../../../bridge/types/state.ts';

export type ForYouTask = {
	id: string; // review chat id
	label: string;
	kind: 'review_replies';
	onActivate: () => void;
};

const isUnreadIgReplyChat = (chat: Chat): boolean =>
	chat.linked_item?.type === 'artifact' &&
	chat.linked_item?.metadata?.artifact_type === 'instagram_comment_reply' &&
	chat.is_unread === true;

export function useForYouTasks(): ForYouTask[] {
	const bridgeApi = useBridgeApi();
	const tasks: ForYouTask[] = [];

	// Not memoized: deltas mutate bridgeApi.user_state.chats in place, so its
	// reference is stable across updates. A useMemo keyed on the chats object
	// would never invalidate, leaving unread state stale until a full refresh.
	for (const [chatId, chat] of Object.entries(
		bridgeApi.user_state?.chats ?? {},
	)) {
		if (!isUnreadIgReplyChat(chat)) continue;
		tasks.push({
			id: chatId,
			label: chat.title ?? 'Review Instagram reply',
			kind: 'review_replies',
			onActivate: () =>
				bridgeApi.sendAction({ type: 'do_switch_chat', chat_id: chatId }),
		});
	}

	return tasks;
}
